/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Starting_ToastInputs */



/**
* | output |
* | --- |
* | "Starting audio embed export..." |
*
* @param {Audio_Embed_Export_Starting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_starting_toast = /** @type {((inputs?: Audio_Embed_Export_Starting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Starting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrage de l'exportation de l'intégration audio...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio-Einbettungs-Export wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio dell'esportazione del contenuto audio incorporato...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало экспорта встроенного аудио...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando la exportación de audio incrustado...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始音频嵌入导出...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声埋め込みのエクスポートを開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो एम्बेड निर्यात शुरू हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a exportação de áudio incorporado...")
	return /** @type {LocalizedString} */ ("Starting audio embed export...")
});